// extracted by mini-css-extract-plugin
export default {"detailPageWrap":"app_detailPageWrap__7sDV8","detailHeader":"app_detailHeader__OKKIr"};